import styled from '@emotion/styled';
import Tip from '../../../components/Tip';
import { Row } from '../../../components/Grid';

export const GeneralTip = styled(Tip)`
  margin-left: 0;
`;

export const Wrapper = styled.div`
  max-width: 600px;
`;

export const NextButtonWrapper = styled(Row)`
  flex: 1;
  max-width: 600px;
  align-content: flex-end;
`;
